import { appPath } from '../../api';
import './crystalHero.css';

/** Homepage-only art direction. Model artwork and the shared SVG wordmarks stay unchanged. */
export default function CrystalHero() {
  return <section className="crystal-hero" aria-labelledby="hero-heading">
    <div className="crystal-hero__art" aria-hidden="true">
      <img className="crystal-hero__poster" src={appPath('/images/hero-minerals-v2-1672.e5cedc600bcb.webp')}
        srcSet={[
          `${appPath('/images/hero-minerals-v2-960.4e7f317b6807.webp')} 960w`,
          `${appPath('/images/hero-minerals-v2-1280.55ca0f51cf22.webp')} 1280w`,
          `${appPath('/images/hero-minerals-v2-1600.9fdea24b4903.webp')} 1600w`,
          `${appPath('/images/hero-minerals-v2-1672.e5cedc600bcb.webp')} 1672w`
        ].join(', ')}
        sizes="(max-width: 359px) max(100vw, 436px), (max-width: 640px) max(100vw, 498px), (max-width: 1000px) 100vw, (min-width: 1800px) min(2200px, max(100vw, 1814px)), max(100vw, 1512px, 177.78svh)"
        width="1672" height="941" alt="" loading="eager" fetchPriority="high" decoding="async"/>
    </div>
    <div className="crystal-hero__copy">
      <h1 id="hero-heading" className="crystal-hero__title">From data<br/>{' '}<span>to discovery</span></h1>
      <p className="crystal-hero__description">Explore routes. See the evidence.<br/>Move your next idea forward.</p>
      <div className="crystal-hero__actions">
        <a className="crystal-hero__button crystal-hero__button--primary" href={appPath('/app')}>Try BlitzSynth free</a>
        <a className="crystal-hero__button crystal-hero__button--secondary" href="#workspace">Explore the workspace</a>
      </div>
      <p className="crystal-hero__access">Free beta · Access on request</p>
    </div>
  </section>;
}
